module.exports = __webpack_public_path__ + "static/media/up-bold-green.5e827458.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/up-bold-green.svg
// module id = ./src/assets/icons/up-bold-green.svg
// module chunks = 0